import { Localizable } from '../localization';

export enum AnnouncementType {
  info = 'info',
  warning = 'warning',
  success = 'success',
  error = 'error',
}

// API type - uses Localizable for cleaner interface
export type Announcement = {
  id: string;
  title: Localizable;
  text: Localizable;
  type: AnnouncementType;
  displayOrder: number;
  createdBy?: string | null;
  createdAt: string;
  updatedBy?: string | null;
  updatedAt: string;
  published: boolean;
  archived: boolean;
};

// Database type - maps to actual DB columns
export type AnnouncementDbRecord = {
  id: string;
  titleEn: string;
  titleFr: string;
  textEn: string;
  textFr: string;
  type: AnnouncementType;
  displayOrder: number;
  createdBy?: string | null;
  createdAt: string;
  updatedBy?: string | null;
  updatedAt: string;
  published: boolean;
  archived: boolean;
};

export type CreateAnnouncementData = {
  title: Localizable;
  text: Localizable;
  type: AnnouncementType;
  published?: boolean;
  displayOrder?: number;
};

export type UpdateAnnouncementData = {
  title?: Localizable;
  text?: Localizable;
  type?: AnnouncementType;
  displayOrder?: number;
  published?: boolean;
  archived?: boolean;
};

export type ReorderAnnouncementData = {
  id: string;
  displayOrder: number;
};

export type AnnouncementColorScheme = {
  background: string;
  border: string;
  text: string;
  icon: string;
};

export const announcementColorSchemes: Record<AnnouncementType, AnnouncementColorScheme> = {
  [AnnouncementType.info]: {
    background: '#e3f2fd',
    border: '#2196f3',
    text: '#1565c0',
    icon: '#2196f3',
  },
  [AnnouncementType.warning]: {
    background: '#fff8e1',
    border: '#ff9800',
    text: '#e65100',
    icon: '#ff9800',
  },
  [AnnouncementType.success]: {
    background: '#e8f5e8',
    border: '#4caf50',
    text: '#2e7d32',
    icon: '#4caf50',
  },
  [AnnouncementType.error]: {
    background: '#ffebee',
    border: '#f44336',
    text: '#c62828',
    icon: '#f44336',
  },
};
